class is {
  static getGeojsonFormat() {
    if (!is.geojsonFormat) {
      is.geojsonFormat = new ol.format.GeoJSON();
    }

    return is.geojsonFormat;
  }

  static createGreatCircleLineGeometry(t, e) {
    let n = oe3aol.turf.greatCircle(t, e);
    return is.getGeojsonFormat().readFeature(n).getGeometry();
  }

  static createGreatCircleLineFeature(t, e) {
    let n = oe3aol.turf.greatCircle(t, e);
    return is.getGeojsonFormat().readFeature(n);
  }

  static createCirclePolygon(t, e, n) {
    return is.getGeojsonFormat().readFeature(oe3aol.turf.circle(t, e, n));
  }

  static bearing(t, e, n, i) {
    t *= Math.PI / 180;
    n *= Math.PI / 180;
    e *= Math.PI / 180;
    i *= Math.PI / 180;
    let r = Math.sin(i - e) * Math.cos(n);

    let o =
      Math.cos(t) * Math.sin(n) - Math.sin(t) * Math.cos(n) * Math.cos(i - e);

    let s = Math.atan2(r, o) * (180 / Math.PI);

    if (s < 0) {
      s += 360;
    }

    return s;
  }
}

is.geojsonFormat = undefined;

export const GeomUtils = is;